import $ from 'qwery';
import Cookies from 'js-cookie';
import MegaModal from './MegaModal';

const CaribouModalNudgeMessage = {
    init () {
        this.element = $('[data-caribou-modal]');

        if (this.element.length === 0) {
            return;
        }

        this.showModalInstance();
    },

    /**
     * Returns a `new MegaModal` instance.
     *
     * {MegaModal.js}
     */
    getModalInstance () {
        return new MegaModal({
            modalType: 'narrow',
            content: '[data-caribou-modal]',
            className: 'u-textCenter,c-caribou-modal',
            clickOutsideToClose: 'false',
            afterShow: () => this.bindUserEvents()
        });
    },

    /**
     * Checks that an instance of the `MegaModal` is available
     * and then displays it based on users session state.
     */
    showModalInstance () {
        this.getModal = this.getModalInstance();

        if (this.isModalContextAvailable(this.getModal)
            && !this.isUsersSessionStateActive()) {
            this.getModal.show();
        }
    },

    /**
     * Returns a `boolean` value based on the `MegaModal` context.
     *
     * @param modalContext
     * @returns {boolean}
     */
    isModalContextAvailable (modalContext) {
        return !!modalContext;
    },

    /**
     * Sets the users cookie state (Session only). So we
     * can only show the `MegaModal` once per session.
     */
    setUsersState () {
        Cookies.set('caribou-modal', 1);
    },

    /**
     * Returns the users session state so we can see if the user has already
     * dismissed the modal previously.
     *
     * e.g moving from the homepage to search, it shouldn't appear again.
     */
    isUsersSessionStateActive () {
        return Cookies.get('caribou-modal') === '1';
    },

    /**
     * Closes the `MegaModal` instance if it already exists.
     */
    closeModalInstance () {
        if (this.isModalContextAvailable(this.getModal)) {
            this.getModal.hide();
        }
    },

    /**
     * Event: `Click` Sets the users session state when the modal is
     * dismissed.
     */
    bindUserEvents () {
        const buttons = $('.btn', this.getModal.modal.el);

        buttons.forEach(element => {
            element.addEventListener('click', () => {
                this.closeModalInstance();
                this.setUsersState();
            });
        });
    }
};

CaribouModalNudgeMessage.init();

export default CaribouModalNudgeMessage;
